import type { Log } from '@blakeelearning/log'
import Service, { service } from '@ember/service'
import type { CallbackErrorDefinition } from 'teacher-ui-client/utils/error-handler'

export default class ResourceConflictService extends Service {
  @service log!: Log

  handleError(operationName: string, error: any) {
    this.log.info(`409 resource conflict during ${operationName}`, error)
    this.refreshPage()
  }

  private refreshPage() {
    document.location.reload()
  }

  /**
   * Provides an errorDefinition intended to be registered with an error-handler instance, that will (by default)
   * use this service's handleError call when 409 conflict error is received
   *
   */
  errorHandlerDefinition(callback?: (arg: any) => void): CallbackErrorDefinition {
    const errorCallback =
      callback ||
      ((error: any) => {
        this.handleError('default error handler definition', error)
      })

    return {
      statusCode: '409',
      callback: errorCallback,
      kind: 'callback',
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'resource-conflict': ResourceConflictService
  }
}
